import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {Request, RequestsMixin, GET} from 'requests';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import MainNavMixin from '../mixins/MainNavMixin';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const NotFoundController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [MainNavMixin, RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    const {kitToken} = this.props;

    return {
      embedCodeUrl: `https://${FORT_AWESOME_USE_URL}/${kitToken}.js`,
      embedCodeScriptTag: `<script src="https://${FORT_AWESOME_USE_URL}/${kitToken}.js"></script>`,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });
  },

  renderMessage(kit) {
    return (
      <div className="well bg-body p-xs-a-2x text-xs-center">
        <h2 className="m-xs-b-lg">
          <i className="ficon ficon-yoda ficon-4x m-xs-b-md block"></i>
          <span className="block m-xs-b-sm">Found nothing we have.</span>
          <span className="block text-xl">Consumed by the Dark Side this page has become.</span>
        </h2>
        <div className="lead font-weight-normal">
          <p>Hmmm, you may have hit a bad link or typed in a URL incorrectly. Double-check that this address is correct or <Link to={`/kits/${kit.token}`}>go back to your kit</Link>.</p>
          <p className="m-xs-b-0">If you keep running into trouble,  <a href="mailto:help@fortawesome.com">Let us know</a>.</p>
        </div>
      </div>
    );
  },

  renderKit() {
    const {
      kitToken,
    } = this.props;
    const {
      kit: kitRequest,
      subscription: subscriptionRequest,
    } = this.requests;

    const rm = this.resourceManager();
    const kit = rm.type(kitRequest, 'kits').find({token: kitToken});
    const subscription = rm.type(subscriptionRequest, 'subscriptions').get();

    return (
      <div className="well bg-white will-fill-page p-xs-a-lg">
        <div className="kit-summary gg gg-middle m-xs-b-sm">
          <h1 className="text-3x gg-col kit-title">
            <span>
              <Link className="link-dashed-none" to={`/kits/${kit.token}`}>
                {kit.name}
              </Link>
            </span>
          </h1>
        </div>
        {this.renderNav(kit, subscription)}
        <div className="kit-components">
          {this.renderMessage(kit)}
        </div>
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true}>
          <div className="well bg-white will-fill-page p-xs-a-lg is-loading">
            <Spinner size={SIZE_LARGE} />
          </div>
        </Requesting>
        <Done all={true} render={this.renderKit} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(NotFoundController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/NotFoundController.js